import { NgModule } from '@angular/core';

import {
  NavigationActionTiming,
  StoreRouterConnectingModule
} from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';

import { environment } from 'src/environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { DomainAuthModule } from './auth/auth.module';
import { CustomRouterStateSerializer, reducer } from './router';
import { RouterEffects } from './router/effects/router.effects';
import { DomainSalesModule } from './sales/sales.module';
import { DomainCompaniesModule } from './companies/companies.module';
import { DomainSubscriptionModule } from './subscription/subscription.module';
import { DomainUsersModule } from './users/users.module';
import { DomainDidsModule } from './dids/dids.module';
import { DomainTrialKitModule } from './trial-kit/trial-kit.module';
import { DomainEquipmentModule } from './equipment/equipment.module';
import { DomainReviewsModule } from './reviews/reviews.module';
import { DomainSupportDevicesModule } from './support-devices/support-devices.module';
import { DomainQueuesModule } from './queues/queues.module';
import { DomainPartnerModule } from './partner/partner.module';
import { DomainPaymentModule } from './payment/payment.module';
import { DomainConnectivityModule } from './connectivity/connectivity.module';
import { DomainInternalFacilitiesModule } from './internal-facilities/internal-facilities.module';
import { DomainIntegrationsModule } from './integrations/integrations.module';
import { DomainSMSModule } from './sms/sms.module';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forRoot(reducer),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
      serializer: CustomRouterStateSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation
    }),
    StoreDevtoolsModule.instrument({
      name: 'Godpanel',
      maxAge: 10,
      logOnly: environment.production
    }),
    EffectsModule.forRoot([RouterEffects]),
    DomainAuthModule,
    DomainSalesModule,
    DomainCompaniesModule,
    DomainSubscriptionModule,
    DomainUsersModule,
    DomainDidsModule,
    DomainTrialKitModule,
    DomainSupportDevicesModule,
    DomainEquipmentModule,
    DomainReviewsModule,
    DomainQueuesModule,
    DomainPartnerModule,
    DomainPaymentModule,
    DomainConnectivityModule,
    DomainInternalFacilitiesModule,
    DomainIntegrationsModule,
    DomainSMSModule
  ]
})
export class DomainModule { }
